import { Form, Switch } from "antd";
import React from "react";

const ClientServer: React.FC = () => {
  return (
    <Form.Item name="shouldForwardToOrganizationServer" label="Forward To Client Server?" valuePropName="checked">
      <Switch  />
    </Form.Item>
  );
};

export default ClientServer;
